import React from "react";
import { newsSectionData } from "../../../../assets/data/homeData";
import { SectionTop, SectionCardStraight } from "../../../../components";

export default function ExploreSection() {
	return (
		<section className="no-px-md">
			<SectionTop
				heading="News"
				description="Find out what we have recently been doing to support our community."
			/>

			<SectionCardStraight data={newsSectionData} />
		</section>
	);
}
